import React from 'react';
export var ShootingStar = function (_a) {
    var color = _a.color;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
        React.createElement("path", { d: "m5.146 1.01 1.028 2.714h2a.49.49 0 0 1 .345.856L6.786 5.79 7.745 8a.524.524 0 0 1-.746.654L4.674 7.346 2.35 8.654A.524.524 0 0 1 1.6 8l.966-2.21L.83 4.58a.49.49 0 0 1 .344-.856h2L4.2 1.011a.533.533 0 0 1 .946 0ZM9.614 7.333 15 9.901a.25.25 0 0 1-.058.47l-4.263.853v3.692a.25.25 0 0 1-.456.142l-3.2-4.677", stroke: color, strokeLinecap: "round", strokeLinejoin: "round" })));
};
export default ShootingStar;
